import { render, staticRenderFns } from "./CanvalCode.vue?vue&type=template&id=9e52cd42&scoped=true&"
import script from "./CanvalCode.vue?vue&type=script&lang=js&"
export * from "./CanvalCode.vue?vue&type=script&lang=js&"
import style0 from "./CanvalCode.vue?vue&type=style&index=0&id=9e52cd42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e52cd42",
  null
  
)

export default component.exports